// TODO replace by circuit.model.ts
export const CIRCUIT_ATTRIBUTES = {
  id: undefined,
  type: '',
  name: '',
  accessibility: false,
  reasons: '',
  warnings: '',
  suggested_lever_order: '',
  study: {
    jsonApi: 'hasMany',
    type: 'study',
  },
  person: {
    jsonApi: 'hasMany',
    type: 'person',
  },
  levers: {
    jsonApi: 'hasMany',
    type: 'levers',
  },
}

// TODO replace by aggregatedSeries.model.ts
export const AGGREGATED_SERIES_MODEL = {
  id: undefined,
  from_date: '',
  timeseries: [],
  details: [],
  order: 0,
  aggregate_kind: '',
  to_date: '',
  type: '',
  portfolios: {
    jsonApi: 'hasMany',
    type: 'genericModel',
  },
}

// TODO replace by option.model.ts
export const OPTION_ATTRIBUTES = {
  matrimonial_regimes: [],
  pacs_conventions: '',
  portfolio_ids_by_matrimonial_regime: {},
}

// TODO replace by lever.model.ts
export const LEVERS_ATTRIBUTES = {
  accessibility: false,
  circuit: '',
  issues: [],
  name: '',
  current_state: {},
  options: {
    jsonApi: 'hasMany',
    type: 'options',
  },
}
// used for secondary relationships that don't have a proper model defined
// can be a temporary solution till all the db schema is defined
export const GENERIC_MODEL = {}

// TODO replace by aggregation.model.ts
export const AGGREGATION_ATTRIBUTES = {
  results: [],
  sources: {
    jsonApi: 'hasMany',
    type: 'genericModel',
  },
}
